'use client';

import FormSelect from '@/components/form/FormSelect/FormSelect';
import { Locales, type LocalesType } from '@/types';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './LocaleSwitch.module.scss';

function LocaleSwitch() {
  const router = useRouter();
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      selectLocale: i18n.resolvedLanguage as LocalesType,
    },
  });

  // 言語切り替え
  const handleLanguageSwitching = (locale: LocalesType) => {
    if (isLoading) return;
    setIsLoading(true);
    i18n.changeLanguage(locale);

    const params = new URLSearchParams(location.search);
    params.set('lang', locale);
    const newQuery = params.toString();
    router.push(`?${newQuery}`, { scroll: false });
    setIsLoading(false);
  };

  const changeSelectLocale = async () => {
    handleLanguageSwitching(getValues('selectLocale') as LocalesType);
  };

  const locales = Object.keys(Locales) as LocalesType[];

  return (
    <div className={styles.listContainer} data-testid='locale-switch'>
      <FormSelect
        label='言語 / Language'
        name='selectLocale'
        control={control}
        required
        outlined
        items={locales.map((locale) => ({
          value: locale,
          text: Locales[locale].text,
        }))}
        onChange={changeSelectLocale}
        disabled={isLoading}
      />
    </div>
  );
}

export default LocaleSwitch;
